import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { typography } from '@agnivo/ui';
/**
 * Composed empty state (brand-vibe review 2026-07-14, "composed empty states") — a
 * calm centred block: a small ember-tinted glyph, a clear title, a supportive line,
 * and (where it helps) one primary action. Replaces the lonely muted sentence.
 * Restrained by design — a simple outline glyph, not a mascot (identity anti-pattern).
 */
export function EmptyState({ icon, title, body, action, }) {
    return (
    // ag-enter-rise: empty states appear on a settled load — enter softly
    // (motion vocabulary, base.css).
    _jsxs("div", { className: "ag-enter-rise mx-auto mt-16 flex max-w-sm flex-col items-center px-4 text-center", children: [icon && (_jsx("div", { "aria-hidden": "true", className: "mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-accent/10 text-accent", children: icon })), _jsx("h2", { className: typography.heading, children: title }), body && _jsx("p", { className: "mt-1 text-muted", children: body }), action && _jsx("div", { className: "mt-4", children: action })] }));
}
//# sourceMappingURL=EmptyState.js.map